import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

export const DocumentTable = ({
  headers,
  values,
}: {
  headers: Record<string, string>;
  values: Record<string, string>[];
}) => {
  const headerKeys = Object.keys(headers);

  return (
    <Table>
      <TableHead>
        <TableRow>
          {headerKeys.map((headerKey) => (
            <TableCell key={headerKey}>{headers[headerKey]}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {values.map((value, index) => (
          <TableRow key={index}>
            {headerKeys.map((headerKey) => (
              <TableCell key={headerKey}>{value[headerKey]}</TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
